import { z, ZodType } from 'zod'

/**
 * Create a schema matches anything and returns a value. Use it with `or`:
 *
 * const schema = zod.number();
 * const tolerant = schema.or(fallback(-1));
 *
 * schema.parse('foo')      // => ZodError
 * tolerant.parse('foo')    // -1
 *
 * It also applies when the key is missing from an object. The `optional()` is what lets Zod 4 accept an absent key;
 * without it, `z.object({ a: schema.or(fallback(-1)) }).parse({})` fails with "expected nonoptional".
 *
 * @see https://github.com/colinhacks/zod/issues/316#issuecomment-2081302212
 */
export function fallback<T>(value: T): ZodType<T> {
	return z.any().optional().transform(() => value)
}
